import React, { useState } from 'react';

const Login = () => {
  const [isLogin, setIsLogin] = useState(true);
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    name: '',
    phone: '',
    confirmPassword: '',
    otp: ''
  });
  const [showOTP, setShowOTP] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isLogin) {
      // Handle login
      console.log('Login:', formData);
      alert('Login successful! Welcome back.');
    } else {
      // Handle registration
      if (formData.password !== formData.confirmPassword) {
        alert('Passwords do not match!');
        return;
      }
      setShowOTP(true);
      console.log('Registration:', formData);
    }
  };

  const handleOTPSubmit = (e) => {
    e.preventDefault();
    console.log('OTP:', formData.otp);
    alert('Registration successful! Please login with your credentials.');
    setIsLogin(true);
    setShowOTP(false);
    setFormData({
      email: '',
      password: '',
      name: '',
      phone: '',
      confirmPassword: '',
      otp: ''
    });
  };

  const handleSendOTP = () => {
    alert('OTP sent to your registered mobile number!');
  };

  return (
    <div>
      {/* Header */}
      <section className="hero">
        <div className="container">
          <div className="hero-content">
            <h1>{isLogin ? 'Welcome Back' : 'Create Account'}</h1>
            <p>{isLogin ? 'Login to access your account' : 'Join FACTO ELECTRONICAL family'}</p>
            <p style={{ fontSize: '1rem', color: '#999', marginTop: '1rem' }}>
              {isLogin ? 'Access your dashboard and manage orders' : 'Get exclusive offers and updates'}
            </p>
          </div>
        </div>
      </section>

      {/* Login/Register Form */}
      <section>
        <div className="container">
          <div style={{ maxWidth: '500px', margin: '0 auto' }}>
            <div className="card">
              {/* Tab Switcher */}
              <div style={{ 
                display: 'flex', 
                marginBottom: '2rem',
                borderBottom: '1px solid var(--border)'
              }}>
                <button
                  className={`btn ${isLogin ? '' : 'btn-secondary'}`}
                  onClick={() => setIsLogin(true)}
                  style={{ 
                    borderRadius: '0',
                    borderBottom: isLogin ? '2px solid var(--accent)' : 'none',
                    marginBottom: '-1px'
                  }}
                >
                  Login
                </button>
                <button
                  className={`btn ${!isLogin ? '' : 'btn-secondary'}`}
                  onClick={() => setIsLogin(false)}
                  style={{ 
                    borderRadius: '0',
                    borderBottom: !isLogin ? '2px solid var(--accent)' : 'none',
                    marginBottom: '-1px'
                  }}
                >
                  Register
                </button>
              </div>

              {!showOTP ? (
                <form onSubmit={handleSubmit}>
                  {!isLogin && (
                    <>
                      <div className="form-group">
                        <label>Full Name *</label>
                        <input
                          type="text"
                          name="name"
                          value={formData.name}
                          onChange={handleInputChange}
                          required={!isLogin}
                        />
                      </div>
                      
                      <div className="form-group">
                        <label>Phone Number *</label>
                        <input
                          type="tel"
                          name="phone"
                          value={formData.phone}
                          onChange={handleInputChange}
                          required={!isLogin}
                        />
                      </div>
                    </>
                  )}

                  <div className="form-group">
                    <label>Email Address *</label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label>Password *</label>
                    <input
                      type="password"
                      name="password"
                      value={formData.password}
                      onChange={handleInputChange}
                      required
                    />
                  </div>

                  {!isLogin && (
                    <div className="form-group">
                      <label>Confirm Password *</label>
                      <input
                        type="password"
                        name="confirmPassword"
                        value={formData.confirmPassword}
                        onChange={handleInputChange}
                        required={!isLogin}
                      />
                    </div>
                  )}

                  {isLogin && (
                    <div style={{ 
                      display: 'flex', 
                      justifyContent: 'space-between', 
                      alignItems: 'center',
                      marginBottom: '1.5rem'
                    }}>
                      <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                        <input type="checkbox" />
                        <span style={{ color: '#ccc', fontSize: '0.9rem' }}>
                          Remember me
                        </span>
                      </label>
                      <button 
                        type="button" 
                        className="btn-secondary"
                        style={{ padding: '0.5rem 1rem', fontSize: '0.9rem' }}
                        onClick={() => setShowOTP(true)}
                      >
                        Login with OTP
                      </button>
                    </div>
                  )}

                  <button type="submit" className="btn" style={{ width: '100%' }}>
                    {isLogin ? 'Login' : 'Register'}
                  </button>

                  {isLogin && (
                    <div style={{ textAlign: 'center', marginTop: '1rem' }}>
                      <button 
                        type="button" 
                        className="btn-secondary"
                        style={{ fontSize: '0.9rem' }}
                      >
                        Forgot Password?
                      </button>
                    </div>
                  )}
                </form>
              ) : (
                <form onSubmit={handleOTPSubmit}>
                  <div className="form-group">
                    <label>Enter OTP sent to {formData.phone || 'your mobile number'}</label>
                    <input
                      type="text"
                      name="otp"
                      value={formData.otp}
                      onChange={handleInputChange}
                      placeholder="Enter 6-digit OTP"
                      maxLength="6"
                      required
                    />
                  </div>

                  <button type="submit" className="btn" style={{ width: '100%', marginBottom: '1rem' }}>
                    Verify OTP
                  </button>

                  <button 
                    type="button" 
                    className="btn-secondary" 
                    style={{ width: '100%' }}
                    onClick={handleSendOTP}
                  >
                    Resend OTP
                  </button>

                  <button 
                    type="button" 
                    className="btn-secondary" 
                    style={{ width: '100%', marginTop: '1rem' }}
                    onClick={() => setShowOTP(false)}
                  >
                    Back to {isLogin ? 'Login' : 'Register'}
                  </button>
                </form>
              )}

              {/* Social Login */}
              {!showOTP && (
                <div style={{ marginTop: '2rem', paddingTop: '2rem', borderTop: '1px solid var(--border)' }}>
                  <p style={{ textAlign: 'center', color: '#999', marginBottom: '1rem' }}>
                    Or continue with
                  </p>
                  <div style={{ display: 'flex', gap: '1rem' }}>
                    <button className="btn-secondary" style={{ flex: 1 }}>
                      Google
                    </button>
                    <button className="btn-secondary" style={{ flex: 1 }}>
                      Facebook
                    </button>
                  </div>
                </div>
              )}
            </div>

            {/* Benefits */}
            {!showOTP && (
              <div className="card" style={{ marginTop: '2rem' }}>
                <h3 style={{ color: 'var(--accent)', marginBottom: '1rem', textAlign: 'center' }}>
                  {isLogin ? 'Welcome Back!' : 'Join FACTO ELECTRONICAL'}
                </h3>
                <ul style={{ listStyle: 'none', padding: 0 }}>
                  {isLogin ? (
                    <>
                      <li style={{ 
                        padding: '0.5rem 0', 
                        color: '#ccc',
                        borderBottom: '1px solid var(--border)'
                      }}>
                        ✓ Track your orders
                      </li>
                      <li style={{ 
                        padding: '0.5rem 0', 
                        color: '#ccc',
                        borderBottom: '1px solid var(--border)'
                      }}>
                        ✓ View order history
                      </li>
                      <li style={{ 
                        padding: '0.5rem 0', 
                        color: '#ccc',
                        borderBottom: '1px solid var(--border)'
                      }}>
                        ✓ Manage your account
                      </li>
                      <li style={{ 
                        padding: '0.5rem 0', 
                        color: '#ccc'
                      }}>
                        ✓ Get exclusive offers
                      </li>
                    </>
                  ) : (
                    <>
                      <li style={{ 
                        padding: '0.5rem 0', 
                        color: '#ccc',
                        borderBottom: '1px solid var(--border)'
                      }}>
                        ✓ Exclusive member discounts
                      </li>
                      <li style={{ 
                        padding: '0.5rem 0', 
                        color: '#ccc',
                        borderBottom: '1px solid var(--border)'
                      }}>
                        ✓ Early access to new products
                      </li>
                      <li style={{ 
                        padding: '0.5rem 0', 
                        color: '#ccc',
                        borderBottom: '1px solid var(--border)'
                      }}>
                        ✓ Priority customer support
                      </li>
                      <li style={{ 
                        padding: '0.5rem 0', 
                        color: '#ccc'
                      }}>
                        ✓ Newsletter with lighting tips
                      </li>
                    </>
                  )}
                </ul>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* Help Section */}
      <section style={{ backgroundColor: 'var(--secondary)' }}>
        <div className="container">
          <div className="grid grid-3">
            <div className="card" style={{ textAlign: 'center' }}>
              <div style={{ 
                fontSize: '2rem', 
                marginBottom: '1rem'
              }}>
                🔒
              </div>
              <h4 style={{ color: 'var(--accent)', marginBottom: '0.5rem' }}>
                Secure Login
              </h4>
              <p style={{ fontSize: '0.9rem', color: '#ccc' }}>
                Your data is protected with industry-standard encryption
              </p>
            </div>
            
            <div className="card" style={{ textAlign: 'center' }}>
              <div style={{ 
                fontSize: '2rem', 
                marginBottom: '1rem'
              }}>
                🚀
              </div>
              <h4 style={{ color: 'var(--accent)', marginBottom: '0.5rem' }}>
                Quick Access
              </h4>
              <p style={{ fontSize: '0.9rem', color: '#ccc' }}>
                Login once and stay connected across all devices
              </p>
            </div>
            
            <div className="card" style={{ textAlign: 'center' }}>
              <div style={{ 
                fontSize: '2rem', 
                marginBottom: '1rem'
              }}>
                💬
              </div>
              <h4 style={{ color: 'var(--accent)', marginBottom: '0.5rem' }}>
                24/7 Support
              </h4>
              <p style={{ fontSize: '0.9rem', color: '#ccc' }}>
                Get help anytime with account-related queries
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Login;
